import dayjs from "dayjs"
import dayjsBusinessDays from "dayjs-business-days"
import utc from "dayjs/plugin/utc"
import timezonePlugin from "dayjs/plugin/timezone"
import { useEffect } from "react"
import { toast } from "react-toastify"
dayjs.extend(timezonePlugin)
dayjs.extend(utc)
export const getQueryParams = () => {
  const url = new URL(window.location)
  const params = new URLSearchParams(url.search)
  const getParams = Object.fromEntries([...params])
  return getParams
}

export const getPickerItem = ({ dateString, displayFormat, timeFormat }) => {
  if (!dateString) return null
  const [hour, minute] = dateString?.split(":")
  const sendAtDate = dayjs()
    .startOf("day")
    .add(hour ?? 0, "hours")
    ?.add(minute ?? 0, "minutes")
  return {
    text: sendAtDate.format(displayFormat ?? "HH:mm"),
    value: sendAtDate.format(timeFormat ?? "HH:mm"),
    id: sendAtDate.format(timeFormat ?? "HH:mm"),
  }
}

export const debouncer = (func, timeout) => {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}

export const isPointInPolygon = (polygon) => (point) => {
  const x = point.lat
  const y = point.lng

  let inside = false
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].lat
    const yi = polygon[i].lng
    const xj = polygon[j].lat
    const yj = polygon[j].lng

    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
    if (intersect) inside = !inside
  }

  return { ...point, inside }
}

export const addBusinessDays = (date, days, returnDate = false) => {
  if (!days) return dayjs(date).format("YYYY-MM-DD HH:mmZ")
  dayjs.extend(dayjsBusinessDays)
  const retDate = dayjs(date).businessDaysAdd(days).subtract(1, "minute")
  if (returnDate) return retDate

  return retDate.format("YYYY-MM-DD HH:mmZ")
}

export const getBusinessDiff = (date1, date2) => {
  // return 1

  return dayjs(date1).businessDiff(dayjs(date2))
}

export const addBusinessDaysAsIs = (date, days) => {
  dayjs.extend(dayjsBusinessDays)
  return dayjs(date).businessDaysAdd(days)
}

export const resetQuickbooksAccessToken = async (token) => {
  // Get refresh Token
  const myHeaders = new Headers()
  myHeaders.append("Accept", "application/json")
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded")
  myHeaders.append(
    "Authorization",
    "Basic QUJpdFUzNEs5N2g4NDFqZzdFRkYzVmo2UUdEWVV1V1JDTkcwMm9iQ1Z6Uk5jRkxYcFc6dlJCdjRGcXJOSkVQZ1BORUZ2YkFvQWhpSmJLYlU3VUtUSXRLUDJTZA=="
  )

  const urlencoded = new URLSearchParams()
  urlencoded.append("grant_type", "refresh_token")
  urlencoded.append("refresh_token", token)

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: urlencoded,
    redirect: "follow",
  }

  return fetch(
    "https://oauth.platform.intuit.com/oauth2/v1/tokens/bearer",
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.log("error", error))
}

export const roundFinalPrice = (price, options = {}) => {
  if (!price && price != 0) return options?.default ?? price

  try {
    return parseFloat(price).toLocaleString(undefined, {
      minimumFractionDigits: options?.min ?? 4,
      maximumFractionDigits: options?.max ?? 4,
    })
  } catch (error) {
    console.error("roundFinalPrice", error)
    return options?.default ?? price
  }
}

// 2.25535.toFixed(4) giving 2.2553 instead of 2.2554
export const betterRounding = (
  num,
  decimalPlaces,
  defaultValue,
  forceDecimalPlaces
) => {
  try {
    if (!num && num != 0) return defaultValue ?? num
    if (isNaN(parseFloat(num))) return defaultValue ?? num
    const factor = Math.pow(10, decimalPlaces ?? 4)
    if (forceDecimalPlaces) return Math.round(num * factor) / factor
    return (Math.round(num * factor) / factor)?.toFixed(decimalPlaces ?? 4)
  } catch (error) {
    console.error("betterRounding:error", error)
    return defaultValue ?? num
  }
}

export const formatDateWithTimezone = ({
  date,
  timezone,
  format,
  defaultValue,
}) => {
  try {
    if (!dayjs(date).isValid()) return defaultValue ?? date
    if (!timezone) dayjs(date)?.format(format ?? "MM/DD HH:mm")
    return dayjs(date)
      .tz(timezone)
      ?.format(format ?? "MM/DD HH:mm")
  } catch (error) {
    console.log("volume_time:error", error)
    return defaultValue ?? date
  }
}

export const downloadEmlAttachment =
  ({ content, filename }) =>
  () => {
    try {
      const blob = new Blob([content], { type: "application/octet-stream" })
      const url = URL.createObjectURL(blob)
      const a = document.createElement("a")
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(url)
    } catch (error) {
      console.log("attachment-saving-failed", error)
      toast.error(`Attachment download failed, Please retry`, {
        position: "top-right",
        autoClose: 2000,
      })
    }
  }

export const minutesToHoursAndMinutes = (minStr) => {
  const mins = parseInt(minStr, 10)
  if (isNaN(mins)) return "-"

  const hours = Math.floor(mins / 60)
  const minutes = mins % 60
  return `${hours}h ${minutes}m`
}
